<template>
  <div class="view">
    <!-- <MapPlaceholder
      v-if="placeholder.enabled"
      :style="{ 'min-height': height, 'max-height': height }"
      v-bind="{ settings: placeholder, sources: map.sources }"
    /> -->

    <MapComponent
      ref="map"
      v-bind="map"
      :style="{ 'min-height': height, 'max-height': height }"
      @map-loaded="onMapLoaded"
      @map-click="onMapClick"
      @zoom="onMapZoom"
    >
      <MapMarker
        v-for="(marker, index) in trackPoints"
        :key="marker.properties.id"
        v-bind="{ id: marker.properties.id, marker }"
        :primary="index == trackPoints.length - 1"
      >
        <div
          class="point"
          :class="{ small: index != trackPoints.length - 1 }"
        />
      </MapMarker>

      <Popup v-slot="{ marker }">
        <template v-if="marker">
          <div
            v-for="(item, key) in pluckSensorsData(marker)"
            :key="key"
          >
            {{ item.name }} : {{ item.value }}
          </div>
        </template>
      </Popup>
    </MapComponent>

    <RoadPlan />
  </div>
</template>


<script>
import MapMarker from './Marker.vue';
import MapComponent from './MapComponent';
import Popup from './MapComponent/Popup';
import RoadPlan from './RoadPlan';
import { mapGetters, mapActions, mapMutations } from 'vuex';
import { _prepareLineGeoJSON, prepareMarkersPointsFeature } from './utils';

// import MapPlaceholder from "./MapPlaceholder";
import { debounce } from 'debounce';

const DISTANCE_MAP = [
  512000, 512000, 512000, 256000, 128000, 64000, 32000, 16000, 8000, 4000, 4000,
  4000, 4000, 4000, 4000, 4000, 4000, 4000, 4000, 4000, 4000, 4000, 4000, 4000,
  4000,
];

const MAP_ZOOM_DEBOUNCE = 200;

export default {
  components: {
    MapComponent,
    MapMarker,
    Popup,
    RoadPlan,
    // MapPlaceholder,
  },
  beforeRouteLeave(to, from, next) {
    this.foldMap();
    next();
  },
  data() {
    return {
      placeholder: {
        enabled: true,
        rect: null,
        url: null,
      },
      height: '35%',
      map: {
        loaded: false,
        visible: false,
        layers: [],
        sources: [],
        zoom: {
          prev: null,
          current: null,
        },
      },
    };
  },

  computed: {
    ...mapGetters({
      sensorUid: 'shipments/sensorUid',
      track: 'packageDetails/track/list',
      trackParams: 'packageDetails/track/params',
      sensorTypes: 'sensorTypes/list',
      arrowLeftVisible: 'layout/arrowLeftVisible',
      backbuttonEventGenerator: 'layout/backbuttonEventGenerator',
    }),

    trackPoints() {
      if (!this.map.loaded) {
        return [];
      }

      const prepared = prepareMarkersPointsFeature(this.track);

      if (prepared.length == 1) {
        this.$refs.map.focusToPoint(prepared[0].geometry.coordinates)
      }

      const markers = this.$refs.map.getAllMarkers();

      // TODO: Review - probably that is not needed
      for (let key in markers) {
        let found = false;
        for (let pointItem of prepared) {
          if (pointItem.properties.id === key) {
            found = true;
          }
        }
        if (!found) {
          markers[key].remove();
        }
      }

      return prepared;
    },

    readyToInitMapData() {
      return this.map.loaded && this.track && this.track.length > 0;
    },
  },

  watch: {
    backbuttonEventGenerator() {
      this.foldMap();
      this.resizeMapContainer();
    },

    readyToInitMapData: {
      immediate: true,
      handler: function () {
        if (this.readyToInitMapData) {
          console.log('readyToInitMapData');
          this.initMapData();
        }
      },
    },
  },

  async created() {
    // this.map.visible = true;

    this.changeTrackParams({
      distance: DISTANCE_MAP[0],
      hash: this.sensorUid,
    });

    await this.getTrack();

    // mapTimeoutId = setTimeout(async () => {
    // }, 150);
  },

  beforeDestroy() {
    // clearTimeout(mapTimeoutId);
  },



  methods: {
    ...mapActions({
      changeTrackParams: 'packageDetails/track/changeParams',
      getTrack: 'packageDetails/track/getList',
    }),
    ...mapMutations({
      setArrowLeftVisible: 'layout/setArrowLeftVisible',
      setArrowLeftPreventDefault: 'layout/setArrowLeftPreventDefault',
    }),

    onMapLoaded() {
      this.map.loaded = true;
    },

    foldMap() {
      this.setArrowLeftVisible(false);
      this.setArrowLeftPreventDefault(false);
      this.height = '35%';
    },

    pluckSensorsData(marker) {
      const { sensors } = marker.properties.source.sensorData.body;
      let output = {};
      for (const key in sensors) {
        const type = this.sensorTypes[0][key];
        if (!type) {
          continue;
        }
        output[key] = { name: type.name, value: sensors[key] };
      }
      return output;
    },

    initMapData() {
      const id = this.sensorUid;
      const fc = _prepareLineGeoJSON(this.track, id);

      this.map.sources.push(fc);
      const layer = {
        id,
        type: 'line',
        source: id,
        layout: {
          'line-join': 'round',
          'line-cap': 'round',
        },
        paint: {
          'line-color': ['get', 'color'],
          'line-width': 4,
        },
      };

      this.map.layers.push(layer);
    },

    changeMapData() { },

    onMapClick() {
      if (this.height === '35%') {
        this.setArrowLeftVisible(true);
        this.setArrowLeftPreventDefault(true);
        this.height = '100%';
        this.resizeMapContainer();
      }
    },

    onMapZoom: debounce(async function (e) {
      const mapboxMapInstance = e.target;

      const zoom = Math.round(mapboxMapInstance.getZoom());

      this.map.zoom.prev = this.map.zoom.current;
      this.map.zoom.current = zoom;

      const distance = DISTANCE_MAP[zoom];

      // if (this.trackParams.distance === distance) {
      //   return;
      // }

      this.changeTrackParams({ distance, id: this.sensorUid });
      await this.getTrack();

      const fc = _prepareLineGeoJSON(this.track, this.sensorUid);

      this.$refs.map.setSourceData(fc);
    }, MAP_ZOOM_DEBOUNCE),

    resizeMapContainer() {
      this.$refs.map.getMap((mapInstance) => {
        this.$nextTick(() => {
          mapInstance.resize();
          this.$refs.map.focusToAllSources();
        });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.view {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.map-container {
  height: 100%;
}

$defaultPointSize: 16px;

$defaultBorderSize: 4px;

.point {
  z-index: 1000;
  cursor: pointer;
  position: absolute;
  width: $defaultPointSize;
  height: $defaultPointSize;
  left: -$defaultPointSize / 2;
  top: -$defaultPointSize / 2;
  border: $defaultBorderSize solid #ffffff;
  border-radius: 100px;
  box-shadow: 0px 1px 2px rgba(71, 75, 109, 0.4);
  background-color: $accentBlue;

  &.small {
    z-index: 100;
    width: 10px;
    height: 10px;
    border: 3px solid #ffffff;
    left: -5px;
    top: -5px;
    box-shadow: 0px 1px 2px rgba(71, 75, 109, 0.4);
  }
}

.point-container {
  position: relative;
}
</style>